export function eventColor(
    isDateCompleteEvent,
    isDatePastEvent,
    isDateUpcomingEvent,
    serviceHasVaccineSubmodule,
    serviceHasPregnancyDelaySubmodule,
    isDateInsideDelay,
    isDateInsideTolerance
) {
    if (isDateCompleteEvent || isDatePastEvent) {
        return 'complete-avails-background';
    }
    else if (isDateUpcomingEvent) {
        return 'upcoming-avails-background';
    }
    else {
        if (serviceHasVaccineSubmodule || serviceHasPregnancyDelaySubmodule) {
            if (isDateInsideDelay) {
                return 'main-avails-background-kids';
            }
            else if (isDateInsideTolerance) {
                return 'tolerance-avails-background';
            }
            else {
                return 'complete-avails-background';
            }
        }
        else {
            return 'main-avails-background';
        }
    }
}
